module.exports = __webpack_public_path__ + "static/media/img6.a916e5d2.jpg";